<div class="sales-order-dropdown-action-cell-renderer__wrapper">
  <button
    mat-icon-button
    [matMenuTriggerFor]="menu"
    aria-label="Actions"
    (click)="$event.stopPropagation()"
  >
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item style="display: none"></button>
    <button
      mat-menu-item
      [cpPosition]="'auto'"
      [cpPositionOffset]="'50%'"
      [cpPositionRelativeToArrow]="true"
      [cpCancelButton]="true"
      [cpOKButton]="true"
      [cpPresetColors]="colorPalette"
      [cpOKButtonText]="'Apply'"
      [cpSaveClickOutside]="false"
      [(colorPicker)]="selectedColor"
      (click)="$event.stopPropagation()"
      (colorPickerSelect)="applyBackgroundColor($event)"
    >
      <i class="fa fa-paint-brush"></i> Set Background Color
    </button>
    <button mat-menu-item (click)="gotoViewSalesOrder()">
      <i class="fas fa-chart-bar text-info"></i> View Sales Order
    </button>
    <button
      *ngIf="params.data | canEditSalesOrder"
      mat-menu-item
      (click)="editSalesOrder()"
    >
      <i class="fas fa-edit"></i> Edit Sales Order
    </button>
    <button
      *ngIf="!params.data?.picklist && params.data?.isPosted"
      mat-menu-item
      (click)="openCreatePicklistModal()"
    >
      <i class="fas fa-list-alt text-info"></i> Create Picklist
    </button>
    <button
      *ngIf="ftPickAndPackEnabled && isPicking"
      mat-menu-item
      (click)="gotoVisualPicking()"
    >
      <i class="fas fa-list-alt text-info"></i> Visual Picking
    </button>
    <button
      *ngIf="ftPickAndPackEnabled && isPacking"
      mat-menu-item
      (click)="gotoPackingPage()"
    >
      <i class="fas fa-list-alt text-info"></i> Packing Page
    </button>
    <button mat-menu-item (click)="openCreateTrackingNumber()">
      <i class="fas fa-plus-circle"></i> Tracking Numbers
    </button>
    <button *ngIf="showHoldOrderAction" mat-menu-item (click)="holdOrder()">
      <i class="fas fa-clock"></i> Hold Order
    </button>
    <button mat-menu-item (click)="updateTags()">
      <i class="fas fa-edit"></i> Update Tags
    </button>
    <button *ngIf="showSetToPendingButton" mat-menu-item (click)="setToPending()">
      <i class="fas fa-clock"></i> Set To Pending
    </button>
    <button
      *ngIf="shouldShowPrintShippingLabelButton"
      mat-menu-item
      (click)="printShippingLabel()"
    >
      <i class="fas fa-truck"></i> Print Shipping Label
    </button>
    <button mat-menu-item (click)="updateCustomFields()">
      <i class="fas fa-edit"></i> Update Custom Fields
    </button>
    <button mat-menu-item *ngIf="!params.data?.hasFlaggedTag" (click)="flagOrder()">
      <i class="fas fa-flag"></i> Flag Order
    </button>
    <button mat-menu-item (click)="pushFulfillment()">
      <i class="fas fa-share"></i> Push Tracking to Sales Channel
    </button>

    <button
      mat-menu-item
      *ngIf="params.data?.hasFlaggedTag"
      (click)="unFlagOrder()"
    >
      <i class="fas fa-flag text-danger"></i> Unflag Order
    </button>
    <button *ngIf="isPosted" mat-menu-item (click)="onUnpostOrder()">
      <i class="fas fa-undo text-danger"></i> Unallocate Order
    </button>

    <button mat-menu-item *ngIf="canApproveOrReject" (click)="approveOrder()">
      <i class="fas fa-check"></i> Approve
    </button>

    <button mat-menu-item *ngIf="canApproveOrReject" (click)="rejectOrder()">
      <i class="fas fa-times"></i> Reject
    </button>

    <button
      *ngIf="ftEdiIntegrationEnabled && isPosted"
      mat-menu-item
      (click)="createSalesOrderInvoice()"
    >
      <i class="fas fa-edit"></i> Create Sales Order Invoice
    </button>

    <button
      *ngIf="canSendEdi810"
      mat-menu-item
      (click)="onSendEdiTransactionDocument(ediTransactionNumberConstant.TXN_810)"
    >
      <i class="fas fa-paper-plane"></i> Send EDI 810
    </button>

    <button
      *ngIf="canSendEdi"
      mat-menu-item
      (click)="onSendEdiTransactionDocument(ediTransactionNumberConstant.TXN_855)"
    >
      <i class="fas fa-paper-plane"></i> Send EDI 855
    </button>

    <button
      *ngIf="canSendEdi"
      mat-menu-item
      (click)="onSendEdiTransactionDocument(ediTransactionNumberConstant.TXN_856)"
    >
      <i class="fas fa-paper-plane"></i> Send EDI 856
    </button>

    <button *ngIf="canDeleteSalesOrder" mat-menu-item (click)="deleteSalesOrder()">
      <i class="fas fa-trash text-danger"></i> Delete Sales Order
    </button>
  </mat-menu>
</div>
